import { FileDocumentMultipleIcon } from './FileDocumentMultipleIcon';

/**
 * author: Robbert Gurdeep Singh
 * id 05A5AF1D-055E-4FBB-BDD4-D20F3EF105DC
 * name file-document-multiple
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-document-multiple.svg
 * tags
 * - Files / Folders 
 */
export const FileTextMultipleIcon = FileDocumentMultipleIcon;
export default FileTextMultipleIcon